import rawProfiles from '../../../../assets/data/fundraiser-profiles.json';
import type {
  FundraiserProfile,
  FundraiserProfileRegistry,
} from '../models/fundraising-comparison.models';
import { validateFundraiserProfileRegistry } from './fundraiser-profile.validator.mjs';

export const FUNDRAISER_PROFILE_REGISTRY: FundraiserProfileRegistry =
  validateFundraiserProfileRegistry(rawProfiles);

export function getFundraiserProfile(profileId?: string): FundraiserProfile {
  return (
    FUNDRAISER_PROFILE_REGISTRY.profiles.find(
      (profile) => profile.id === profileId,
    ) ??
    FUNDRAISER_PROFILE_REGISTRY.profiles.find(
      (profile) => profile.id === FUNDRAISER_PROFILE_REGISTRY.defaultProfileId,
    )!
  );
}
